import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  GetPackageCategoriesProps,
  CreatePackageProps,
} from "../declarations/tourServices";
import {
  GetPackageCategories,
  CreatePackage,
  CreatePrePackage,
  GetPrePackage,
  GetPackageById,
  GetPlatformFee,
  GetPackage,
  GetPackageData,
  GetOptions,
  ApprovePackage,
  RejectPackage,
  DeletePackage,
  GetPackagesById,
  UpdatePackage,
  CreatePrePackageJson,
} from "../api/services/package";
import { useToast } from "./useToast";
import { RootState } from "../app/store";
import {
  setPackageCategories,
  setPackageData,
  setPackageId,
  setPrePackageData,
  setPrePackagesData,
} from "../reducer/tourReducer";
import {
  CreateSpecialOffers,
  DeleteSpecialOffer,
  GetSpecialOfferById,
  GetSpecialOffers,
  UpdateSpecialOffer,
  UpdateSpecialOfferStatus,
} from "../api/services/specialOffer";
import { SpecialOfferRequest } from "../declarations/specialOffer";
// import { tourCommision } from "../utils/contants";

export function usePackage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showResponseMessages } = useToast();
  const { packageCategories, feeValue } = useSelector(
    (state: RootState) => state.tour
  );

  // const calculateCommision = (num?: number): number => {
  //   let value = 0;
  //   if (num) {
  //     const percentage = tourCommision / 100;
  //     const commision = num * percentage;
  //     value = commision;
  //   }
  //   return value;
  // };

  const calculateNetProfit = (num?: number): number => {
    let value = 0;

    const fee: any = feeValue;

    // if (num === undefined || isNaN(fee)) {
    //   return 0;
    // }

    if (num) {
      const percentage = fee / 100;
      const commision = num * percentage;
      value = num - commision;
    }
    console.log("val", value);
    return value;
  };

  const getPackageCategories = async (query: GetPackageCategoriesProps) => {
    if (packageCategories && packageCategories.length > 0) return;
    const response = await GetPackageCategories(query);
    const { message, status, categories, errors } = response;

    if (status === 200) {
      categories && dispatch(setPackageCategories(categories));
    } else {
      showResponseMessages(status, message, errors);
    }
  };

  const createPackage = async (payload: CreatePackageProps) => {
    try {
      const response = await CreatePackage(payload);
      const { message, status, packageData, errors } = response;

      if (status === 201 && packageData && packageData.length > 0) {
        const id = packageData[0]._id ?? "";
        dispatch(setPackageId(id));
        message && toast["success"](message);
      } else {
        message && toast["error"](message);
      }

      return response;
    } catch (error) {
      toast.error("An error occurred while creating the package.");
    }
  };
  const createPrePackage = async (payload: FormData | any) => {
    try {
      const response = await CreatePrePackage({ payload });
      const { message, status, packageData, errors } = response;

      if (status === 201) {
        message && toast["success"](message);
      } else {
        message && toast["error"](message);
      }

      return response;
    } catch (error) {
      toast.error("An error occurred while creating the package.");
      throw error;
    }
  };
  const createPrePackageJson = async (payload: FormData | any) => {
    try {
      const response = await CreatePrePackageJson({ payload });
      const { message, status } = response;

      if (status === 201) {
        message && toast["success"](message);
      } else {
        message && toast["error"](message);
      }

      return response;
    } catch (error) {
      toast.error("An error occurred while creating the package.");
      throw error;
    }
  };

  const getPrePackage = async (query: any) => {
    const response = await GetPrePackage(query);
    console.log("get pre package", response);
    const { message, status, prePackages, errors } = response;
    if (status === 200) {
      dispatch(setPrePackagesData(prePackages)); // Store in prePackagesData
    } else {
      showResponseMessages(status, message, errors);
    }

    return response;
  };

  const getPackageById = async (
    query: { setLoading: (loading: boolean) => void },
    id: string
  ): Promise<any> => {
    try {
      console.log("query", id);
      const response = await GetPackageById({ ...query, id });
      console.log("response", response);

      const { success, packageresponse, message, errors } = response;
      showResponseMessages(message, errors);
      if (success) {
        dispatch(setPackageData(packageresponse));
      }

      return response;
    } catch (error) {
      console.error("Error in getPackageById:", error);
      throw error;
    }
  };

  const getPackagesById = async (
    query: { setLoading: (loading: boolean) => void },
    id: string
  ): Promise<any> => {
    try {
      console.log("query", id);
      const response = await GetPackagesById({ ...query, id });
      console.log("response", response);

      const { success, packageData, message, errors } = response;
      showResponseMessages(message, errors);
      if (success) {
        dispatch(setPackageData(packageData));
      }
      return response;
    } catch (error) {
      console.error("Error in getPackageById:", error);
      throw error;
    }
  };

  const getPlatformFee = async (query: any) => {
    const response = await GetPlatformFee(query);

    const { status, value, type } = response;

    return response;
  };

  const specialOffers = async (query: { formData: SpecialOfferRequest }) => {
    try {
      console.log("query payload:", query.formData);
      const response = await CreateSpecialOffers({ payload: query.formData });
      console.log("resp:", response);
      const { message, status, errors } = response;

      if (status === 201) {
        toast.success("Special offer created successfully.");
      } else {
        message && toast["error"]("Someting went wrong during creation");
      }
      return response;
    } catch (error) {
      console.error("Error in creating special offer:", error);
    }
  };

  const getSpecialOffers = async () => {
    const response = await GetSpecialOffers();
    console.log("response", response);
    const { message, status, errors } = response;
    if (status === 200) {
      showResponseMessages(status, message, errors);
    } else {
      showResponseMessages(status, message, errors);
    }

    return response;
  };

  const getPackage = async (query: any) => {
    const response = await GetPackage(query);
    console.log("response", response);
    const { message, status, errors } = response;
    if (status === 200) {
      showResponseMessages(status, message, errors);
    } else {
      showResponseMessages(status, message, errors);
    }

    return response;
  };

  const getOption = async (query: any) => {
    const response = await GetOptions(query);
    console.log("response", response);
    const { message, status, errors } = response;
    if (status === 200) {
      showResponseMessages(status, message, errors);
    } else {
      showResponseMessages(status, message, errors);
    }

    return response;
  };

  const getPackageData = async () => {
    const response = await GetPackageData();
    console.log("response", response);
    const { message, status, errors } = response;
    if (status === 200) {
      showResponseMessages(status, message, errors);
    } else {
      showResponseMessages(status, message, errors);
    }

    return response;
  };

  const deleteSpecialOffer = async (query: any) => {
    const response = await DeleteSpecialOffer(query.id);

    const { message, status, errors } = response;
    if (status === 200) {
      message && toast["success"](message);
    } else {
      showResponseMessages(status, message, errors);
    }

    return response;
  };

  const getSpecialOfferyId = async (id: string): Promise<any> => {
    try {
      const response = await GetSpecialOfferById(id);

      const { success, packageresponse, message, errors } = response;
      showResponseMessages(success, message, errors);

      return response;
    } catch (error) {
      console.error("Error in getPackageById:", error);
      throw error;
    }
  };

  const updateSpecialOffer = async (
    formData: any,
    id: string
  ): Promise<any> => {
    try {
      console.log("query", id);
      const response = await UpdateSpecialOffer(formData, id);
      console.log("responseupdate", response);
      const { message, success, specialOffer, errors, status } = response;
      if (status == 200) {
        message && toast["success"](message);
      }
      showResponseMessages(message, errors);

      return response;
    } catch (error) {
      console.error("Error in getPackageById:", error);
      throw error;
    }
  };

  const updateSpecialOfferStatus = async (
    statusData: any,
    id: string
  ): Promise<any> => {
    try {
      console.log("query", id);
      const response = await UpdateSpecialOfferStatus(statusData, id);
      console.log("responseupdate", response);
      const { message, success, specialOffer, errors, status } = response;
      if (status == 200) {
        message && toast["success"](message);
      }
      showResponseMessages(message, errors);

      return response;
    } catch (error) {
      console.error("Error in getPackageById:", error);
      throw error;
    }
  };

  const approvePackage = async (id: string): Promise<any> => {
    try {
      const response = await ApprovePackage(id);
      console.log("response", response);
      const { message, status, errors } = response;
      if (status === 200) {
        message && toast["success"](message);
      } else {
        showResponseMessages(status, message, errors);
      }
      return response;
    } catch (error) {
      console.error("Error in approvePackage:", error);
      throw error;
    }
  };

  const rejectPackage = async (id: string, payload: any): Promise<any> => {
    try {
      const response = await RejectPackage(id, payload);
      console.log("response", response);
      const { message, status, errors } = response;
      if (status === 200) {
        message && toast["success"](message);
      } else {
        showResponseMessages(status, message, errors);
      }
      return response;
    } catch (error) {
      console.error("Error in rejectPackage:", error);
      throw error;
    }
  };

  const deletePackage = async (id: string): Promise<any> => {
    try {
      const response = await DeletePackage(id);
      console.log("response", response);
      const { message, status, errors } = response;
      if (status === 200) {
        message && toast["success"](message);
      } else {
        showResponseMessages(status, message, errors);
      }
      return response;
    } catch (error) {
      console.error("Error in deletePackage:", error);
      throw error;
    }
  };

  const updatePackage = async (id: string, payload: any): Promise<any> => {
    try {
      const response = await UpdatePackage({ id, payload });
      console.log("response updatePackage", response);
      const { message, status, errors } = response;
      if (status === 200) {
        message && toast["success"](message);
      } else {
        showResponseMessages(status, message, errors);
      }
      return response;
    } catch (error) {
      console.error("Error in updatePackage:", error);
      throw error;
    }
  };

  return {
    getPackageCategories,
    getPrePackage,
    getPackageById,
    createPackage,
    // calculateCommision,
    calculateNetProfit,
    createPrePackage,
    createPrePackageJson,
    getPlatformFee,
    specialOffers,
    getSpecialOffers,
    getPackage,
    getPackageData,
    getOption,
    deleteSpecialOffer,
    getSpecialOfferyId,
    updateSpecialOffer,
    updateSpecialOfferStatus,
    approvePackage,
    rejectPackage,
    deletePackage,
    getPackagesById,
    updatePackage,
  };
}
